import { Injectable } from '@angular/core';



@Injectable()
export class StringUtils{ 

    constructor(){}

   public isNotEmpty(str:string){
        return (str!= undefined && str!= null && str.trim()!= "" && str.trim().length!=0);
    }


}


// WEBPACK FOOTER //
// ./src/app/shared/utils/stringUtils.ts